<template>

    <el-container style="height:100vh">
        <el-aside width="">
            <div class="container">
                <h2>{{friendlyName}}</h2>
                <span>{{friendlyUploadMessage}}</span>
                <ul v-if="this.requirement != null && this.requirement.certConfig != null && this.requirement.certConfig.files !== null && this.requirement.certConfig.files.length > 1">
                    <li v-for="file in requirement.certConfig.files" :key="file.reference">
                        {{file.description}} <span v-if="file.required" style="color:#f56c6c;">*</span>
                    </li>
                </ul>
            </div>
        </el-aside>
        <el-main>
            <el-row type="flex" align="middle">
                <i v-show="!requirement" class="el-icon-loading"></i>

                <el-col id="spacer" :lg="2" :xl="3"></el-col>
                <el-col :xs="24" :sm="22" :md="20" :lg="18" :xl="12">

                    <div v-if="requirement !== null">

                        <div v-if="requirement.status == 'Complete'">
                            <el-alert type="warning" title="Certification has already been uploaded"></el-alert>
                        </div>

                        <div v-else-if="linkExpired">
                            <el-alert type="info" :closable="false" show-icon title="This link is no longer valid." description="If you believe this to be in error, please contact us."></el-alert>
                        </div>

                        <div v-else-if="requirement.status != 'Complete'">
                            <el-form-builder v-if="requirement.certConfig.metaData != null" :config="formConfig" v-show="!uploadSuccess" v-model="formValues" ref="ruleForm" label-width="">
                            </el-form-builder>
                            <div class="form-container" v-show="!uploadSuccess">

                                <el-upload :auto-upload="false"
                                           drag
                                           action="https://jsonplaceholder.typicode.com/posts/"
                                           :on-change="onFileChange"
                                           :on-remove="onFileRemoved"
                                           multiple>
                                    <i class="el-icon-upload"></i>
                                    <div class="el-upload__text">Drop files here or <em>click to upload</em></div>
                                </el-upload>
                                <div class="el-form-item__error">{{fileValidationError}}</div>
                            </div>
                            <div class="form-container">
                                <transition name="fade">
                                    <div v-show="uploadSuccess" class="text-center success-message">
                                        <i class="el-icon-success text-success"></i>
                                        <h2>Your certification was uploaded successfully.</h2>
                                    </div>
                                </transition>

                                <div v-if="showRequestError">
                                    <el-alert type="error">{{requestError}}</el-alert>
                                </div>

                                <div class="submit-container" v-if="!uploadSuccess">
                                    <el-button v-if="showUploadBtn" type="primary" @click.native="submit(false)" :loading="isSubmitting">{{ !isSubmitting ? "Upload" : "Uploading..."}}</el-button>
                                </div>
                            </div>

                        </div>

                    </div>

                    <el-alert type="error" title="This link is invalid" :closable="false" show-icon description="Please check the URL and try again." v-if="invalidRequirement"></el-alert>

                </el-col>
            </el-row>
            <b-modal
                id="check-modal"
                v-model="showModal"
                ok-title="Continue"
                ok-variant="success"
                title="Confirmation"
                @ok="submit(true)">
                <p>{{modalText}}</p>
                <ul>
                    <li v-for="err in fileErrors" :key="err.id">
                        {{err.msg}}<br />
                    </li>
                </ul>
            </b-modal>
        </el-main>
    </el-container>

</template>

<script>
    import moment from 'moment'
    import Vue from 'vue'

    export default {
        data() {
            return {
                modalText: "",
                requestError: "",
                showRequestError: false,
                showModal: false,
                invalidRequirement: false,
                uploadSuccess: false,
                files: [],
                fileErrors: [],
                fileValidationError: null,
                formValues: {},
                formConfig: {
                    rules: {},
                    elements: []
                },
				isSubmitting: false,
                nonChangeableData:[]
            }
        },
        props: {
            tenantId: {
                required: true,
                type: String
            },
            contactIdHash: {
                required: true,
                type: String
            },
            certRequirementId: {
                required: true,
                type: String
            }
        },
        methods: {
            submit(override) {

                this.isSubmitting = true;
                let isValid = true;
                this.showRequestError = false;

                // validate form
                if (this.requirement.certConfig.metaData != null) {
                    this.$refs['ruleForm'].$children[0].validate((valid) => {
                        isValid = valid;
                    });
                }

                // validate files
                this.fileValidationError = null;

                if (this.requirement.certConfig.files !== null) {
                    let requiredCount = this.requirement.certConfig.files
                        .filter(x => x.required).length;

                    if (requiredCount > 0) {
                        if (this.files.length < requiredCount) {
                            this.fileValidationError = `${requiredCount} files are required for this cert`;
                            isValid = false;
                        }
                    }
                }


                if (isValid) {

                    let formData = new FormData();
                    formData.append('contactId', this.requirement.contactId);
                    formData.append('tenantId', this.tenantId);
                    formData.append('overrideValidation', override);

                    for (var i = 0; i < this.files.length; i++) {
                        formData.append(`files[${i}]`, this.files[i]);
                    }
                    let foundDateKeys = Object.keys(this.formValues).filter(x => x.includes("DateUTC"));

					//Todo: set dynamic date format for different countries from inputs
                    foundDateKeys.forEach(x => {
                        var inputDate = new Date(this.formValues[x]);
                        if (x == "expiryDateUTC")  this.formValues["expiryInputDate"] = inputDate.getDate() + '/' + (inputDate.getMonth() + 1) + '/' + inputDate.getFullYear();
						if (x == "obtainedDateUTC")  this.formValues["obtainedInputDate"] = inputDate.getDate() + '/' + (inputDate.getMonth() + 1) + '/' + inputDate.getFullYear();
						if (x == "dateOfBirthDateUTC") {
							var dateDay= inputDate.getDate();
							var dateMonth= inputDate.getMonth() + 1;
							var paddedDay = dateDay.toString().length < 2 ? "0" + dateDay.toString() : dateDay.toString();
							var paddedMonth = dateMonth.toString().length < 2 ? "0" + dateMonth.toString() : dateMonth.toString();

							this.formValues["dateOfBirthInputDate"] = paddedDay + '/' + paddedMonth + '/' + inputDate.getFullYear().toString();
						}  
						
                        this.formValues[x] = moment.utc(this.formValues[x]).format();
                    });

					if ( this.nonChangeableData.length > 0 ) {
						this.nonChangeableData.forEach(prop => {
							this.formValues[prop.propertyName] = prop.propertyValue;						
						});				
					}

                    formData.append('metaDataJson', JSON.stringify(this.formValues));

                    let postObj = {
                        requirementId: this.requirement.id,
                        formData: formData
                    }

                    this.$store.dispatch('certifications/upload', postObj)
                        .then(() => {

                            this.isSubmitting = false;
                            this.uploadSuccess = true;

                            this.uploadErrors = [];
                            this.files = [];

                            if (this.requirement.returnUrl) {

                                let friendlyCertName = this.requirement.friendlyType != null ? this.requirement.friendlyType : '';
                                let firstName = this.formValues.firstName != null ? this.formValues.firstName : '';
                                let lastName = this.formValues.lastName != null ? this.formValues.lastName : '';

                                let queryStringChar = this.requirement.returnUrl.indexOf('?') != -1 ? '&' : '?';

                                window.location.href = encodeURI(`${this.requirement.returnUrl}${queryStringChar}firstName=${firstName}&lastName=${lastName}&friendlyCertName=${friendlyCertName}`);
                            }

                        }, error => {
                            this.isSubmitting = false;
                            if (error.response.data.errors != null && error.response.data.errors.length > 0) {
                                this.showModal = true;
                                this.fileErrors = [];
                                this.modalText = 'Before proceeding, please confirm that: ';
                                this.fileErrors.push({ id: 1, msg: 'The image is high quality'});
                                if (error.response.data.errors.filter(err => err.errorCode == 'keyword_not_recognised').length > 0) {
                                    this.fileErrors.push({ id: 2, msg: 'All wording in the image is clear'})
                                }
                                if (error.response.data.errors.filter(err => err.errorCode == 'date_not_recognised').length > 0) {
                                    this.fileErrors.push({ id: 3, msg: 'The image is the most recent version of the certification'})
                                }
                                if (error.response.data.errors.filter(err => err.errorCode == 'failed_metadata_validation' || err.errorCode == 'service_not_available').length > 0) {
                                    this.fileErrors.push({ id: 4, msg: 'The certification is registered and valid'})
                                }
                                this.$refs["check-modal"].show();
                            }
                            else {
                                this.requestError = error.response.data.message;
                                this.showRequestError = true;
                            }

                        })

                } else {
                    this.isSubmitting = false;
                    return false;
                }
            },
            onFileChange(file) {
                this.files.push(file.raw);
                if (this.uploadErrors != null && this.uploadErrors.length > 0) {
                    this.uploadErrors = this.uploadErrors.filter(x => { return x.errorCode != 'file_not_recognised' });
                }
            },
            onFileRemoved(file) {
                this.files.splice(this.files.indexOf(this.files.find(x => x.name == file.name)), 1);
            }
        },
        computed: {
            requirement() {
                return this.$store.state.certRequirements.requirement;
            },
            linkExpired() {
                return this.requirement.expiryDateUTC != null && moment(this.requirement.expiryDateUTC).isBefore(moment.utc());
            },
            friendlyName() {

                if (this.requirement != null && this.requirement.certConfig != null) {
                    let prepend = this.requirement.certificationId !== null ? "Update" : "Upload";
                    return `${prepend} your ${this.requirement.certConfig.friendlyName}`;
                } else return null;

            },
            friendlyUploadMessage() {
                if (this.requirement != null && this.requirement.certConfig != null) {
                    if (this.requirement.certConfig.files !== null && this.requirement.certConfig.files.length == 1) {
                        return "Please fill in the form and provide an upload of the file";
                    }
                    return "Please fill in the form and provide the following files:";
                }

                return null;
            },
            showUploadBtn() {
                return !this.uploadSuccess;
            }
        },
        created() {
            this.$store.dispatch('certRequirements/get', {
                tenantId: this.tenantId,
                contactIdHash: this.contactIdHash,
                certRequirementId: this.certRequirementId
            })
                .then(response => {

                    // Build form from config

                    // Files


                    // Meta Data
                    if (response.data && response.data.certConfig
                        && response.data.certConfig.metaData
                        && response.data.certConfig.metaData.length > 0) {

                        let formConfig = {
                            rules: {},
                            elements: []
                        };

                        if (response.data.externalSystemMetaData != null && response.data.externalSystemMetaData.length > 0) {
                            response.data.certConfig.metaData.forEach(prop => {
                                if (prop.changeable == false) {
                                    var fieldObj = {}
                                    var matchedProp = response.data.externalSystemMetaData.find(m => m.propertyName == prop.propertyName);
                                    if (matchedProp != null) {
                                        fieldObj["propertyName"] = matchedProp.propertyName
                                        fieldObj["propertyValue"] = matchedProp.propertyValue
                                        this.nonChangeableData.push(fieldObj)
                                    }
                                }
                            });


                            //filter only changeable fields	
                            response.data.certConfig.metaData = response.data.certConfig.metaData.filter(item => item.changeable == true)
                        }

                        for (var configItem of response.data.certConfig.metaData) {

                            let existingVal =
                                configItem.formField.populateOnUpdate &&
                                    response.data.existingCertMetaData != null &&
                                    response.data.existingCertMetaData[configItem.propertyName] != null
                                    ? response.data.existingCertMetaData[configItem.propertyName] : null;

                            Vue.set(this.formValues, configItem.propertyName, existingVal)

                            let rules = [];

                            if (configItem.required) {
                                rules.push({ required: true, message: `${configItem.formField.label} is required` });
                            }

                            switch (configItem.formField.type) {
                                case 'text-input':

                                    if (configItem.type === 'number') {
                                        rules.push({ type: 'number', message: `${configItem.formField.label} requires a number` })
                                    }

                                    formConfig.elements.push({
                                        tag: 'el-input',
                                        item: {
                                            label: configItem.formField.label
                                        },
                                        detail: {
                                            name: configItem.propertyName,
                                            placeholder: configItem.formField.placeholder
                                        }
                                    });

                                    break;
                                case 'date-picker':

                                    formConfig.elements.push({
                                        tag: 'el-date-picker',
                                        item: {
                                            label: configItem.formField.label
                                        },
                                        detail: {
                                            name: configItem.propertyName,
                                            placeholder: configItem.formField.placeholder,
                                            format: configItem.formField.format,
                                            pickerOptions: configItem.propertyName.includes('expiry') ? {
                                                disabledDate(date) {
                                                    return date < Date.now();
                                                } 
                                            }
                                            : null 
                                        },
                                        
                                    });

                                    break;

                                case 'select':

                                    formConfig.elements.push({
                                        tag: 'el-select',
                                        item: {
                                            label: configItem.formField.label
                                        },
                                        detail: {
                                            name: configItem.propertyName,
                                            multiple: false,
                                            items: configItem.formField.items
                                        }
                                    });

                                    break;

                                default:
                                    break;
                            }

                            formConfig.rules[configItem.propertyName] = rules;

                        }

                        this.formConfig = formConfig

                    }

                }, error => {
                    this.invalidRequirement = true;
                })
        }
    }
</script>

<style lang="scss">
    body {
        font-size: 16px;
        margin: 0;
        font-family: Arial, Helvetica, sans-serif;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 100% !important;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .success-message {
        i{
            font-size: 3rem;
        }
    }

    .text-success {
        color: #67C23A;
    }

    .text-center {
        text-align: center;
    }


    .el-aside {
        display: flex;
        flex-flow: column nowrap;
        background-color: rgb(0,173,239);
        color: #fff;
        padding: 40px;
        width: 25%;
        min-width: 300px;
        max-width: 400px;
        .container {
            position: relative;
            top: calc(50% - 175px);
        }
    }

    .submit-container {
        display: flex;
        padding: 0.5rem 0;
        align-items: center;
        .el-button{
            margin-left: auto;
        }

    }

    .el-icon-loading {
        font-size: 32px;
        position: absolute;
        top: calc(50% - 16px);
        left: calc(50% - 16px);
    }

    .el-row {
        height: 100%;
    }

    .form-container {
        position: relative;
        margin-left: 150px;
        width: calc(100% - 150px);
        .el-upload,.el-upload-dragger{
            width: 100%;
        }

    }

    .el-form-item {
        display: flex;
        .el-form-item__label{
            width: 150px !important;
        }

        .el-form-item__content {
            flex-grow: 1;
        }
    }

    @media only screen and (max-width:1200px) {
        #spacer {
            display: none;
        }
    }

    @media only screen and (max-width:997px) {
        .el-container {
            flex-flow: column wrap;
        }

        .el-aside {
            flex-grow: 0;
            height: min-content;
            width: 100%;
            min-width: 0;
            max-width: none;
            .container{
                top: 0;
            }
        }

        .el-container {
            align-content: flex-start;
        }

        .el-row {
            min-height: 100px;
        }
    }

    @media only screen and (max-width:576px) {
        .form-container {
            margin-top: 1.5rem;
            margin-left: 0;
            width: 100%;
        }

        .el-aside {
            padding: 20px;
        }

        .el-upload-dragger {
            height: 90px !important;
            .el-icon-upload  {
                line-height: 1 !important;
                font-size: 3.2rem !important;
                margin: 10px 0 4px !important;
            }

        }

        .el-form-item {
            flex-flow: column nowrap;
            margin-bottom: 0.6rem !important;
            .el-form-item__label{
                width: 100% !important;
                text-align: left;
            }
        }
    }
    
</style>
